// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"WrapperList_Wrapper__z3yW0","Text":"WrapperList_Text__TPHpq","Active":"WrapperList_Active__rtcwe","ActiveService":"WrapperList_ActiveService__tvFGz"};